import { X } from 'lucide-react';

/**
 * Export Format Selection Modal
 * Allows user to choose between Word, PDF, or Text format
 */
export default function ExportFormatModal({ 
  isOpen, 
  onClose, 
  onSelect, 
  title = 'Select Export Format',
  isLoading = false 
}) {
  if (!isOpen) return null;

  const formats = [
    { 
      id: 'docx', 
      label: 'Word Document (.docx)', 
      icon: '📄',
      description: 'Microsoft Word format with formatting preserved'
    },
    { 
      id: 'doc', 
      label: 'Word 97-2003 (.doc)', 
      icon: '📝',
      description: 'Legacy Word format for compatibility'
    },
    { 
      id: 'txt', 
      label: 'Plain Text (.txt)', 
      icon: '📋',
      description: 'Text only, no formatting'
    },
  ];

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full max-h-[calc(100dvh-2rem)] overflow-y-auto">
        {/* Header */}
        <div className="border-b border-gray-200 p-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          <button
            onClick={onClose}
            disabled={isLoading}
            className="p-1 hover:bg-gray-100 rounded-lg text-gray-600 disabled:opacity-50"
          >
            <X size={20} />
          </button>
        </div>

        {/* Format Options */}
        <div className="p-4 space-y-3">
          {formats.map((format) => (
            <button
              key={format.id}
              onClick={() => onSelect(format.id)}
              disabled={isLoading}
              className="w-full text-left p-3 border border-gray-200 rounded-lg hover:border-teal-500 hover:bg-teal-50 transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <div className="flex items-start gap-3">
                <span className="text-2xl">{format.icon}</span>
                <div className="flex-1">
                  <p className="font-medium text-gray-900">{format.label}</p>
                  <p className="text-sm text-gray-600">{format.description}</p>
                </div>
              </div>
            </button>
          ))}
        </div>

        {/* Footer */}
        <div className="border-t border-gray-200 p-4">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 font-medium disabled:opacity-50"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
